// Laboratory configuration
export const laboratoryInfo = {
    name: 'ENOVADENT Laboratoire',
    fullName: 'ENOVADENT Laboratoire - Laboratoire de Prothèses Dentaires',
    address: '11 - 13 RUE JEAN LURCAT 95100 ARGENTEUIL',
    postalCode: '95100',
    city: 'ARGENTEUIL',
    country: 'France',
    phone: '06 65 38 14 31 / 07 84 91 25 16',
    email: 'contact@enovadent.com',
    website: 'www.enovadent.com',
    siret: '105 703 763 00018',
    tva: 'FR65105703763',

    // Quote validity in months
    quoteValidity: 3,

    // Terms and conditions
    termsAndConditions: [
        'Ce devis est valable 3 mois à compter de sa date d\'émission.',
        'Les prix sont indiqués en euros TTC.',
        'Paiement à 30 jours fin de mois.',
        'Tout retard de paiement entraînera l\'application de pénalités de retard.'
    ],

    // Price list
    prices: {
        couronne: {
            zircone: 350,
            emax: 380,
            metal: 300,
            composite: 250,
            ceramique: 400
        },
        facette: {
            emax: 400,
            ceramique: 450
        },
        inlay: {
            emax: 280,
            composite: 220,
            ceramique: 300
        },
        onlay: {
            emax: 300,
            composite: 240,
            ceramique: 320
        },
        bridge: {
            zircone: 450,
            metal: 380,
            ceramique: 500
        },
        implant: {
            zircone: 500,
            titane: 450,
            ceramique: 550
        },
        provisoire: {
            composite: 150,
            acrylique: 120
        }
    },

    // Additional costs
    additionalCosts: {
        maquillage: 50,
        clavette: 30,
        opaque: 20,
        transvisse: 40
    }
};

export default laboratoryInfo;
